import script from "./ContactAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactAvatar.vue?vue&type=script&setup=true&lang=ts"

import "./ContactAvatar.vue?vue&type=style&index=0&id=82ed70d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82ed70d0"]])

export default __exports__